<template>
  <v-container>
    <div v-for="(matter, i) in matters" :key="i">
      <div>{{ matter.caseName }}</div>
    </div>
  </v-container>
</template>

<script>
// import firebase from "firebase";
export default {
  data: () => ({}),
  methods: {},
  computed: {
    user() {
      return this.$store.getters.user;
    },
    role() {
      return this.$store.getters.role;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    firm() {
      return this.$store.getters.firm;
    },
    firmIsLoaded() {
      return (
        this.$store.getters.firm !== null &&
        this.$store.getters.firm !== undefined
      );
    },
    matters() {
      //
      let allMatters = this.$store.getters.matters;
      let woolseyMatters = allMatters.filter(
        (matter) =>
          matter.specialTitle && matter.specialTitle === `Woolsey Fire Cases`
      );
      return woolseyMatters;
    },
    mattersAreLoaded() {
      return (
        this.$store.getters.matters !== null &&
        this.$store.getters.matters !== undefined
      );
    },
    // reversedActivities() {
    //   if (this.firm.actvities) {
    //     return this.firm.actvities.slice().reverse();
    //   } else {
    //     return null;
    //   }
    // }
  },

  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        console.log("user from watch", value);
        // this.$store.dispatch("loadMatters", value);
        // this.$router.push('/');
        this.$store.dispatch("getFirm", this.user.firmSlug);
      }
    },

    matters(value) {
      if (value !== null && value !== undefined) {
        console.log("matters from watch", value);
      }
    },
  },
  created() {
    if (this.user) {
      this.$store.dispatch("getFirm", this.user.firmSlug);
    }
    console.log("matters:", this.matters);
  },
};
</script>
